import App from 'pages/_app';

export default App;
